<script setup lang="ts">
const { $pwa, $critical } = useNuxtApp();

async function fetchClear(BUILD_UNIQUE_ID: any) {
  const date: any = new Date();

  try {
    return await fetch(
      '/api/clear-cache?version=' + BUILD_UNIQUE_ID + '&d=' + date * 1,
      {
        headers: {
          Pragma: 'no-cache',
          Expires: '-1',
          'X-Version-Id': BUILD_UNIQUE_ID,
          'Cache-Control': 'no-cache',
        },
      },
    );
  } catch (ex) {
    return null;
  }
}

async function autoUpdate() {
  if (isDev() || isStage()) {
    return;
  }

  let isUpdated = true;

  try {
    const response = await updateWebsite('fetchClear');

    if (response) {
      isUpdated = (await response.json()).isUpdated;
    }
  } catch (ex) {
    return;
  }

  if (!isUpdated) {
    try {
      const x = [
        fetch('/', {
          headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'Cache-Control': 'no-cache',
          },
        }),
      ];

      if (location.href !== '/') {
        x.push(
          fetch(location.href, {
            headers: {
              Pragma: 'no-cache',
              Expires: '-1',
              'Cache-Control': 'no-cache',
            },
          }),
        );
      }
      await Promise.all(x);

      await $critical.fetch({ force: true });
    } catch (ex) {
      return;
    }

    setTimeout(function () {
      // @ts-ignore
      location.reload(true);

      const current = location.href;

      location.href = current;
    }, 1);
  }
}

async function updateWebsite(stopLevel: any) {
  let BUILD_UNIQUE_ID: any = '';

  try {
    BUILD_UNIQUE_ID = document
      .getElementsByName('x-build-id')[0]!
      .getAttribute('content');
  } catch (ex) {}

  if (!BUILD_UNIQUE_ID) {
    BUILD_UNIQUE_ID = '';
  }

  if (stopLevel === 'getBuildId') {
    return BUILD_UNIQUE_ID;
  }

  /**
   * Estes sao os unicos fetchs que devem ser manuais, nao retire eles
   * os outros devem passar pelo ApiService
   */
  if (stopLevel === 'fetchClear') {
    try {
      await $critical.fetch({ force: true });
    } catch (ex) {}

    return fetchClear(BUILD_UNIQUE_ID);
  }

  if (stopLevel !== 'onlyPwa') {
    try {
      const gets = [];

      gets.push(
        fetch('/', {
          headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'X-Version-Id': BUILD_UNIQUE_ID,
            'Cache-Control': 'no-cache',
          },
        }),
      );

      if (location.href !== '/') {
        gets.push(
          fetch(location.href, {
            headers: {
              Pragma: 'no-cache',
              Expires: '-1',
              'X-Version-Id': BUILD_UNIQUE_ID,
              'Cache-Control': 'no-cache',
            },
          }),
        );
      }
      gets.push(fetchClear(BUILD_UNIQUE_ID));
      await Promise.all(gets);
    } catch (ex) {}

    try {
      if ('caches' in window) {
        const cacheKeys = await caches.keys();

        for (let i = 0; i < cacheKeys.length; i++) {
          await caches.delete(cacheKeys[i]!);
        }
      }
    } catch (ex) {}
  }

  const currentUrl = location.href;

  if (stopLevel === 'update' || stopLevel === 'onlyPwa') {
    try {
      await $critical.fetch({ force: true });

      await $pwa?.updateServiceWorker();
    } catch (ex) {}

    return;
  }

  setTimeout(() => {
    try {
      location.reload();
    } catch (ex) {}
    setTimeout(function () {
      location.href = currentUrl;
    }, 10);
  }, 3000);

  try {
    await $pwa?.updateServiceWorker();
  } catch (ex) {}

  location.reload();
  location.href = currentUrl;
}

const needsUpdateTabBar = computed(() => {
  if (!$pwa) {
    return false;
  }

  return $pwa?.needRefresh || false;
});

if (window) {
  window.cactusUpdateWebsite = updateWebsite;
  window.cactusUpdatePwa = $pwa;
  window.cactusAutoUpdate = autoUpdate;
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="needsUpdateTabBar"
      id="needsUpdateTabBar"
      :class="$style.updatePWA"
    >
      <span>
        {{ $t('pwa_update_msg') }}
      </span>

      <button @click="updateWebsite('fetchClear')">
        {{ $t('others.update') }}
      </button>
    </div>
  </Teleport>
</template>

<style module lang="postcss">
.updatePWA {
  @apply fixed w-full flex items-center justify-center gap-3 py-1 px-2 translate-y-0 z-[888] bg-error text-texts text-xs bottom-[56px] lg:bottom-0;

  display: none !important;

  button {
    @apply rounded bg-texts text-error px-1.5 py-0.5 text-xs font-medium;
  }
}
</style>
